import React from 'react';

import Main from '../module_biz/main';

export default [
 {
   path: '/',
   component: Main,
 }
]
